import React, { useState } from 'react';

const DeviceStatePopupHOC = (Component:any) => 
function Comp(props:any){
    const [showDeviceStatePopup,setShowDeviceStatePopup] = useState<boolean>(false);

    const deviceStateToggleHandler = () => {
        setShowDeviceStatePopup(!showDeviceStatePopup);
    }
	
	return <Component showDeviceStatePopup={showDeviceStatePopup} deviceStateToggleHandler={deviceStateToggleHandler} {...props}/>;
};

export default DeviceStatePopupHOC;   